<template lang="pug">
  #l-1(class="l-1 -dress_8ceeea5f2fa14e49a719795cad1c3040", data-type="responsive", data-page-animation="fade")
    #a-footer(data-float="false", class="a-footer   cssskin-_area_footer")

      footer
        .footer-inner
          //- セクション1
          .col-1
            .c-img
              img(src="@/assets/_src/46907/157095208735801.png?v=1664354652501", id="logo", class=" c-no_adjust")
            br
            h3.name DIOデジタル株式会社
            | 〒103-0023
            br
            | 東京都中央区日本橋本町4-15-11 市橋ビル9階
            br
            | Tel.03-6231-0822
            br
            | Fax.03-6231-1822
            br
            | E-mail.info@diodigital.co.jp
          //- セクション2
          .col-2
            h4(class=" c-small_headline") CONTENTS
            p.c-body
              a(href="index.html", data-mypid="1952", ) HOME
              br
              a(href="/clinic/", ) クリニックを探す
              br
              | PRODUCTS
              br
              a(href="https://diodigital.co.jp/generally/dionavi.html") ・DIOnavi.
              br
              a(href="https://diodigital.co.jp/generally/fullarch.html") ・DIOnavi. Full Arch
              br
              a(href="https://ortho.diodigital.co.jp/" target="_blank") ・DIOnavi. Ortho
              br
              |&nbsp;
          //- セクション3
          .col-3
            h4(class=" c-small_headline") &nbsp;
            p.c-body
              a(href="/news/general/", ) NEWS
              br
              a(href="/generally/faq.html", data-pid="1957", ) FAQ
              br
              a(href="/generally/companydata.html", data-pid="1953", ) 企業情報
              br
              a(href="/generally/recruit.html", data-pid="1958", ) 採用情報
              br
              a(href="/generally/contact.html", data-pid="1956", ) お問い合わせ
          //- セクション4
          .col-4
            .sns
              h4(class=" c-small_headline") &nbsp;SNS
              .c-body
                |&nbsp;
                .c-img.sns-icon
                  a(href="https://www.facebook.com/diodigital/", target="_blank", rel="noopener noreferrer")
                    img(src="@/assets/_src/46925/footer_facebook.jpg?v=1664435496982", id="imgsrc46925_1")
                |  &nbsp;
                .c-img.sns-icon
                  a(href="https://www.instagram.com/dio_digital_japan/" target="_blank")
                    img(src="@/assets/_src/46923/footer_instagram.jpg?v=1664435496982", id="imgsrc46923_1")
                br
                |&nbsp;

          p.c-credit COPYRIGHT © 2022〜 DIO&nbsp;DIGITAL CO.,LTD. ALL RIGHTS RESERVED


</template>
<script>
//-import lib from "@/assets/_module/lib/lib.js";
//-import bind from "@/assets/_module/scripts/bind.js";
export default {
  name: "headerC",
  methods: {
    init() {
      //-bind.init();
    },
  },
};
</script>

<style scoped lang="scss">
@use "@/css/utility/_colors" as colors;
@use "@/css/utility/_mixin" as mixin;
@use "@/css/utility/_media" as media;
@use "@/css/utility/_font" as font;
@use "@/css/utility/_variables" as variables;
footer {
  background: #313131;
  font-weight: 400; /* regular */
  * {
    box-sizing: border-box;
  }
}

.footer-inner {
  @include media.max-screen(media.$breakpoint-sm) {
    display: flex;
    flex-wrap: wrap;
    font-size: 13px;
    //color: #b8b8b8;
    color: #ccc;
    line-height: 1.9;
  }
  @include media.min-screen(media.$breakpoint-md) {
    padding-left: 30px;
    padding-top: 70px;
    padding-right: 30px;
    padding-bottom: 50px;
    font-size: 13px;
    //color: #b8b8b8;
    color: #ccc;
    line-height: 1.9;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  a {
    //color: #b8b8b8;
    color: #ccc;
    transition: opacity 0.2s ease;
    &:hover {
      opacity: 0.4;
    }
  }
}
.c-small_headline {
  @include media.max-screen(media.$breakpoint-sm) {
    //color: #d8d8d8;
    color: #eee;
    font-size: 13px;
    font-weight: 700;
  }
  @include media.min-screen(media.$breakpoint-md) {
    color: #d8d8d8;
    font-size: 13px;
    font-weight: 700;
  }
}
.c-img {
  display: inline;
}
// セクション1
.col-1 {
  @include media.max-screen(media.$breakpoint-sm) {
    padding-left: 30px;
    padding-top: 30px;
    padding-right: 30px;
    padding-bottom: 0;
  }
  @include media.min-screen(media.$breakpoint-md) {
    width: 35%;
    padding-left: 30px;
    padding-right: 10px;
    padding-top: 0px;
  }
  .name {
    font-size: 14px;
    color: #b8b8b8;
    font-weight: 500;
    margin-top: 30px;
    line-height: 1.8;
    @include media.min-screen(media.$breakpoint-md) {
      font-size: 14px;
    }
  }
}
#logo {
  @include media.max-screen(media.$breakpoint-sm) {
    width: 200px;
  }
  @include media.min-screen(media.$breakpoint-md) {
    width: 200px;
    padding: 5px 0 0;
    vertical-align: middle;
  }
}
// セクション2
.col-2 {
  @include media.max-screen(media.$breakpoint-sm) {
    padding-left: 30px;
    padding-top: 30px;
    width: 50%;
    padding-right: 10px;
  }
  @include media.min-screen(media.$breakpoint-md) {
    width: 19%;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 75px;
  }
}

// セクション3
.col-3 {
  @include media.max-screen(media.$breakpoint-sm) {
    padding-top: 30px;
    padding-right: 10px;
    padding-left: 10px;
    width: 50%;
    margin-bottom: 25px;
  }
  @include media.min-screen(media.$breakpoint-md) {
    width: 18%;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 75px;
  }
}

// セクション4
.col-4 {
  @include media.max-screen(media.$breakpoint-sm) {
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 8px;
    display: flex;
    width: 100%;
  }
  @include media.min-screen(media.$breakpoint-md) {
    width: 23%;
    padding-left: 10px;
    padding-right: 30px;
    padding-top: 75px;
  }
  img {
    @include media.max-screen(media.$breakpoint-sm) {
      padding-top: 5px;
      //padding-bottom: 3px;
      //margin-left: 3px;
      margin-right: 3px;
    }
    @include media.min-screen(media.$breakpoint-md) {
      padding-top: 5px;
      padding-bottom: 3px;
      margin-left: 3px;
    }
  }
  .c-small_headline {
    @include media.max-screen(media.$breakpoint-sm) {
      display: block;
    }
  }
  .sns {
    @include media.max-screen(media.$breakpoint-sm) {
      width: 50%;
      padding-right: 10px;
      .c-body {
        margin-left: -3px;
      }
    }
  }
  .other {
    @include media.max-screen(media.$breakpoint-sm) {
      padding-right: 10px;
      padding-left: 10px;
      width: 50%;
      padding-top: 24px;
    }
  }
}
// コピーらいと
.c-credit {
  width: 100%;
  @include media.max-screen(media.$breakpoint-sm) {
    padding-left: 15px;
    padding-top: 12px;
    padding-right: 15px;
    padding-bottom: 15px;
    text-align: center;
    font-size: 10px;
    //color: #b8b8b8;
    color: #ccc;
  }
  @include media.min-screen(media.$breakpoint-md) {
    padding-left: 30px;
    padding-top: 50px;
    padding-right: 30px;
    padding-bottom: 0px;
    font-size: 10px;
  }
}
</style>
